module.exports = __webpack_public_path__ + "static/media/purcari.ecc46a2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/screenshots/standart/purcari.png
// module id = 814
// module chunks = 20